import { api } from '../configs/axiosConfigs';

export const getPropertyListUploadsProperties = async (propertyId: string) => {
  return await api.get(`/properties/${propertyId}/list-uploads-properties-data`);
};
